var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signed)?_c('div',[(_vm.list.length)?_c('div',[_c('simple-menu',{attrs:{"menu-list":_vm.menuList}}),_vm._v(" "),_c('div',{staticClass:"small-app-content"},[_c('router-view',{attrs:{"list":_vm.list},on:{"refresh":_vm.getAppList}})],1)],1):_c('div',{staticClass:"empty"},[_vm._v("\n        你暂时没有关联的小程序～\n    ")])]):_c('access-deny')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530ff964","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/upManage/Main.vue
// module id = null
// module chunks = 